import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import Button from '../components/Button';
import Input from '../components/Input';
import { UserIcon, CalendarIcon, DollarSignIcon, CameraIcon, ImageIcon, CheckCircleIcon } from 'lucide-react';
const FinancialSimulator = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('general');
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  const tabs = [{
    id: 'general',
    label: 'Información General'
  }, {
    id: 'debt',
    label: 'Detalle Deuda'
  }, {
    id: 'history',
    label: 'Gestiones Anteriores'
  }, {
    id: 'simulation',
    label: 'Simulación'
  }, {
    id: 'negotiation',
    label: 'Negociación'
  }];
  return <div className="min-h-screen bg-gray-50 pb-20" data-id="element-149">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-150" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-151" />
      <div className="bg-white p-4 shadow-sm overflow-x-auto" data-id="element-152">
        <div className="flex min-w-max" data-id="element-153">
          {tabs.map(tab => <button key={tab.id} className={`px-4 py-2 mr-2 whitespace-nowrap ${activeTab === tab.id ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab(tab.id)} data-id="element-154">
              {tab.label}
            </button>)}
        </div>
      </div>
      <main className="p-4" data-id="element-155">
        {activeTab === 'general' && <Card className="mb-6" data-id="element-156">
            <h2 className="text-lg font-semibold mb-4" data-id="element-157">
              Información del Cliente
            </h2>
            <div className="space-y-4" data-id="element-158">
              <div className="flex items-center" data-id="element-159">
                <UserIcon size={20} className="text-blue-600 mr-3" data-id="element-160" />
                <div data-id="element-161">
                  <div className="text-sm text-gray-500" data-id="element-162">Nombre completo</div>
                  <div className="font-medium" data-id="element-163">Juan Carlos Rodríguez</div>
                </div>
              </div>
              <div className="flex items-center" data-id="element-164">
                <CalendarIcon size={20} className="text-blue-600 mr-3" data-id="element-165" />
                <div data-id="element-166">
                  <div className="text-sm text-gray-500" data-id="element-167">
                    Documento de identidad
                  </div>
                  <div className="font-medium" data-id="element-168">CC 1234567890</div>
                </div>
              </div>
              <div className="flex items-center" data-id="element-169">
                <DollarSignIcon size={20} className="text-blue-600 mr-3" data-id="element-170" />
                <div data-id="element-171">
                  <div className="text-sm text-gray-500" data-id="element-172">Valor total deuda</div>
                  <div className="font-medium text-red-600" data-id="element-173">$2,450,000</div>
                </div>
              </div>
            </div>
          </Card>}
        {activeTab === 'debt' && <div className="space-y-6" data-id="element-174">
            <Card data-id="element-175">
              <h2 className="text-lg font-semibold mb-4" data-id="element-176">
                Detalle de la Deuda
              </h2>
              <div className="space-y-4" data-id="element-177">
                <div className="bg-red-50 p-4 rounded-lg" data-id="element-178">
                  <div className="text-sm text-gray-600" data-id="element-179">Deuda total</div>
                  <div className="text-2xl font-bold text-red-600" data-id="element-180">
                    $2,450,000
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-181">
                  <div data-id="element-182">
                    <div className="text-sm text-gray-600" data-id="element-183">Capital inicial</div>
                    <div className="font-medium" data-id="element-184">$2,000,000</div>
                  </div>
                  <div data-id="element-185">
                    <div className="text-sm text-gray-600" data-id="element-186">Intereses</div>
                    <div className="font-medium" data-id="element-187">$450,000</div>
                  </div>
                  <div data-id="element-188">
                    <div className="text-sm text-gray-600" data-id="element-189">
                      Tasa efectiva anual
                    </div>
                    <div className="font-medium" data-id="element-190">15.2%</div>
                  </div>
                  <div data-id="element-191">
                    <div className="text-sm text-gray-600" data-id="element-192">Días en mora</div>
                    <div className="font-medium text-red-600" data-id="element-193">45</div>
                  </div>
                </div>
              </div>
            </Card>
            <Card data-id="element-194">
              <h3 className="font-semibold mb-4" data-id="element-195">Historial de Pagos</h3>
              <div className="space-y-3" data-id="element-196">
                {[{
              date: '2023-05-15',
              amount: '$150,000',
              status: 'Pagado'
            }, {
              date: '2023-04-15',
              amount: '$150,000',
              status: 'Pagado'
            }, {
              date: '2023-03-15',
              amount: '$150,000',
              status: 'Vencido'
            }].map((payment, index) => <div key={index} className="flex justify-between items-center p-3 border rounded-lg" data-id="element-197">
                    <div data-id="element-198">
                      <div className="font-medium" data-id="element-199">{payment.amount}</div>
                      <div className="text-sm text-gray-600" data-id="element-200">
                        {payment.date}
                      </div>
                    </div>
                    <span className={`px-2 py-1 text-xs rounded-full ${payment.status === 'Pagado' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-201">
                      {payment.status}
                    </span>
                  </div>)}
              </div>
            </Card>
          </div>}
        {activeTab === 'history' && <div className="space-y-6" data-id="element-202">
            <Card data-id="element-203">
              <h2 className="text-lg font-semibold mb-4" data-id="element-204">
                Gestiones Anteriores
              </h2>
              <div className="space-y-4" data-id="element-205">
                {[{
              date: '2023-05-20',
              type: 'Llamada',
              agent: 'Ana Martínez',
              description: 'Cliente solicita información sobre planes de pago'
            }, {
              date: '2023-05-15',
              type: 'Visita',
              agent: 'Carlos Pérez',
              description: 'Se realiza visita domiciliaria, cliente no se encuentra'
            }, {
              date: '2023-05-10',
              type: 'Acuerdo',
              agent: 'María González',
              description: 'Se establece acuerdo de pago por $150,000 mensuales'
            }].map((record, index) => <div key={index} className="p-4 border rounded-lg" data-id="element-206">
                    <div className="flex justify-between mb-2" data-id="element-207">
                      <span className="text-sm text-gray-600" data-id="element-208">
                        {record.date}
                      </span>
                      <span className="text-sm font-medium text-blue-600" data-id="element-209">
                        {record.type}
                      </span>
                    </div>
                    <div className="mb-1 font-medium" data-id="element-210">{record.agent}</div>
                    <p className="text-sm text-gray-600" data-id="element-211">
                      {record.description}
                    </p>
                  </div>)}
              </div>
            </Card>
          </div>}
        {activeTab === 'simulation' && <div className="space-y-6" data-id="element-212">
            <Card data-id="element-213">
              <h2 className="text-lg font-semibold mb-4" data-id="element-214">
                Simulación de Acuerdo
              </h2>
              <Input label="Cuota inicial" placeholder="$0" type="number" data-id="element-215" />
              <div className="mb-4" data-id="element-216">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-217">
                  Plazo (meses)
                </label>
                <div className="flex items-center space-x-2" data-id="element-218">
                  {[6, 12, 18, 24, 36].map(month => <button key={month} className="px-3 py-2 border rounded-lg min-w-[44px] focus:outline-none
                        hover:bg-blue-50 focus:ring-2 focus:ring-blue-500" data-id="element-219">
                      {month}
                    </button>)}
                </div>
              </div>
              <Button fullWidth data-id="element-220">Calcular cuota mensual</Button>
            </Card>
            <Card data-id="element-221">
              <h3 className="text-lg font-semibold mb-4" data-id="element-222">
                Resultado simulación
              </h3>
              <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-223">
                <div className="text-center" data-id="element-224">
                  <div className="text-sm text-gray-600" data-id="element-225">
                    Cuota mensual estimada
                  </div>
                  <div className="text-2xl font-bold text-blue-700" data-id="element-226">
                    $245,000
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-227">
                <div data-id="element-228">
                  <div className="text-sm text-gray-600" data-id="element-229">Cuota inicial</div>
                  <div className="font-medium" data-id="element-230">$500,000</div>
                </div>
                <div data-id="element-231">
                  <div className="text-sm text-gray-600" data-id="element-232">Plazo</div>
                  <div className="font-medium" data-id="element-233">12 meses</div>
                </div>
                <div data-id="element-234">
                  <div className="text-sm text-gray-600" data-id="element-235">Tasa de interés</div>
                  <div className="font-medium" data-id="element-236">1.2% mensual</div>
                </div>
                <div data-id="element-237">
                  <div className="text-sm text-gray-600" data-id="element-238">Total a pagar</div>
                  <div className="font-medium" data-id="element-239">$3,440,000</div>
                </div>
              </div>
              <div className="flex space-x-3" data-id="element-240">
                <Button variant="secondary" data-id="element-241">Modificar</Button>
                <Button data-id="element-242">Aceptar acuerdo</Button>
              </div>
            </Card>
            <Card data-id="element-243">
              <h3 className="text-lg font-semibold mb-4" data-id="element-244">Cargar soportes</h3>
              <div className="flex space-x-3 mb-4" data-id="element-245">
                <button className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-4 hover:bg-gray-50" data-id="element-246">
                  <CameraIcon size={24} className="text-blue-600 mb-2" data-id="element-247" />
                  <span className="text-sm text-gray-600" data-id="element-248">Cámara</span>
                </button>
                <button className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-4 hover:bg-gray-50" data-id="element-249">
                  <ImageIcon size={24} className="text-blue-600 mb-2" data-id="element-250" />
                  <span className="text-sm text-gray-600" data-id="element-251">Galería</span>
                </button>
              </div>
              <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-252">
                <div className="relative" data-id="element-253">
                  <img src="https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60" alt="Document preview" className="w-full h-24 object-cover rounded-lg" data-id="element-254" />
                  <div className="absolute bottom-1 right-1 bg-green-500 text-white rounded-full p-1" data-id="element-255">
                    <CheckCircleIcon size={16} data-id="element-256" />
                  </div>
                </div>
              </div>
              <Input label="Token de confirmación" placeholder="Ingrese el token" data-id="element-257" />
              <Button fullWidth data-id="element-258">Confirmar acuerdo</Button>
            </Card>
          </div>}
        {activeTab === 'negotiation' && <div className="space-y-6" data-id="element-259">
            <Card data-id="element-260">
              <h2 className="text-lg font-semibold mb-4" data-id="element-261">
                Estado de Negociación
              </h2>
              <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-262">
                <div className="text-sm text-gray-600" data-id="element-263">Propuesta actual</div>
                <div className="text-2xl font-bold text-blue-700" data-id="element-264">
                  $245,000/mes
                </div>
                <div className="text-sm text-gray-600" data-id="element-265">por 12 meses</div>
              </div>
              <div className="space-y-4" data-id="element-266">
                <div className="flex items-center justify-between p-3 border rounded-lg" data-id="element-267">
                  <div data-id="element-268">
                    <div className="font-medium" data-id="element-269">Descuento por pronto pago</div>
                    <div className="text-sm text-gray-600" data-id="element-270">
                      Válido hasta: 30/06/2023
                    </div>
                  </div>
                  <span className="text-green-600 font-medium" data-id="element-271">15%</span>
                </div>
                <div className="flex items-center justify-between p-3 border rounded-lg" data-id="element-272">
                  <div data-id="element-273">
                    <div className="font-medium" data-id="element-274">Condonación de intereses</div>
                    <div className="text-sm text-gray-600" data-id="element-275">
                      Sujeto a aprobación
                    </div>
                  </div>
                  <span className="text-amber-600 font-medium" data-id="element-276">Pendiente</span>
                </div>
              </div>
            </Card>
            <Card data-id="element-277">
              <h3 className="font-semibold mb-4" data-id="element-278">Opciones de Negociación</h3>
              <div className="space-y-3" data-id="element-279">
                <button className="w-full p-4 border rounded-lg text-left hover:bg-gray-50" data-id="element-280">
                  <div className="font-medium" data-id="element-281">Plan Flexible</div>
                  <div className="text-sm text-gray-600" data-id="element-282">
                    Cuotas desde $200,000/mes
                  </div>
                </button>
                <button className="w-full p-4 border rounded-lg text-left hover:bg-gray-50" data-id="element-283">
                  <div className="font-medium" data-id="element-284">Pago Único</div>
                  <div className="text-sm text-gray-600" data-id="element-285">20% de descuento</div>
                </button>
                <button className="w-full p-4 border rounded-lg text-left hover:bg-gray-50" data-id="element-286">
                  <div className="font-medium" data-id="element-287">Plan Especial</div>
                  <div className="text-sm text-gray-600" data-id="element-288">
                    Condonación de intereses
                  </div>
                </button>
              </div>
              <div className="mt-6" data-id="element-289">
                <Button fullWidth data-id="element-290">Solicitar nueva negociación</Button>
              </div>
            </Card>
          </div>}
        {/* Other tabs would be implemented here */}
        {(activeTab === 'debt' || activeTab === 'history' || activeTab === 'negotiation') && <div className="flex justify-center items-center h-64" data-id="element-291">
            <p className="text-gray-500" data-id="element-292">
              Contenido de {tabs.find(t => t.id === activeTab)?.label}
            </p>
          </div>}
      </main>
    </div>;
};
export default FinancialSimulator;